module.exports = {
  camelCase: () => []
};
